import React from 'react'
import { Redirect, Route } from 'react-router'

import { useTabLocalInactivity } from '../hooks/useTabLocalInactivity'

import { getFromSessionStorage } from '../utils/util'

const ProtectedRoute = (props) => {
  useTabLocalInactivity()

  if (!getFromSessionStorage('token')) {
    return <Redirect to="/login" />
  }

  return <Route {...props} />
}

export default ProtectedRoute
